import { Component, OnInit } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { AuthService } from './../../shared/services/auth.service';
import { ScoreTrackerService } from '../../shared/services/score-tracker.service';
import { Router } from '@angular/router';
import { AppNavigationService } from '../../shared/services/app-navigation.service';
import { WebSocketService } from 'src/app/shared/services/websocket.service';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { DialogDeviceDebugDialog } from 'src/app/shared/dialogs/device-debug-dialog/device-debug-dialog.component';
import { WebSocketRxjsService } from 'src/app/shared/services/websocket-rxjs.service';


@Component({
  selector: 'app-admin-device-setup',
  templateUrl: './admin-device-setup.component.html',
  styleUrls: ['./admin-device-setup.component.css']
})
export class AdminDeviceSetupComponent implements OnInit {

  showSpinner = false;

  userTokenInfo; 

  deviceDebugDialog: MatDialogRef<DialogDeviceDebugDialog>;

  connectionInfo = {
    adminID: -1,
    playerID: -1,
    deviceName: 'App Device Setup Connection',
    deviceRoomDisplayName: '',
    deviceCourtNumber: '-1',
    connectionSource: 'App Device Setup Page',
    eventID: 0,
    tempEventID: 0,
    tempMatchID: 0 
  }; 

  courtNumbers = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', 
                  '11', '12', '13', '14', '15', '16', '17', '18', '19', 
                  '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', 
                  '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', 
                  '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', 
                  '50', '51', '52', '53', '54', '55', '56', '57', '58', '59', 
                  '60', '61', '62', '63', '64', '65', '66', '67', '68', '69', 
                  '70', '71', '72', '73', '74', '75', '76', '77', '78', '79', 
                  '80', '81', '82', '83', '84', '85', '86', '87', '88', '89', 
                  '90', '91', '92', '93', '94', '95', '96', '97', '98', '99', 
                  '100', '101', '102', '103', '104', '105', '106', '107', '108', 
                  '109', '110', '111', '112', '113', '114', '115', '116', '117', '118', 
                  '119', '120', '121', '122', '123', '124', '125', '126', '127', '128', 
                  '129', '130', '131', '132', '133', '134', '135', '136', '137', '138', 
                  '139', '140', '141', '142', '143', '144', '145', '146', '147', '148', '149', 
                  '150', '151', '152', '153', '154', '155', '156', '157', '158', '159', 
                  '160', '161', '162', '163', '164', '165', '166', '167', '168', '169', 
                  '170', '171', '172', '173', '174', '175', '176', '177', '178', '179', 
                  '180', '181', '182', '183', '184', '185', '186', '187', '188', '189', 
                  '190', '191', '192', '193', '194', '195', '196', '197', '198', '199', 
                  '200'];

  socketInfo;


  showDebug = false;

  constructor( private authService: AuthService,
               private router: Router,
               private appNavigationService: AppNavigationService,
               private scoreTrackerService: ScoreTrackerService,
               private webSocketService: WebSocketService,
               private snackBar: MatSnackBar,
               public dialog: MatDialog) 
               { 
                 // this.appNavigationService.showMenuButton();
               }

  ngOnInit()
  {

    // Get the logged in user id from the local token
    this.userTokenInfo = this.authService.getUserTokenInfo();

    // console.log(this.userTokenInfo);

    this.connectionInfo.adminID = this.userTokenInfo.userID;
    this.connectionInfo.playerID = this.userTokenInfo.userID;

    this.checkDeviceSetup();

    this.webSocketService.socketStatusSubject$.subscribe(
    (data) => 
    {
      this.socketInfo = data;
    },
    (error) => 
    {
      console.log('Error ', error);
      // this.snackBar.open(error, null, { duration: 5000 });
      alert(error);
    });    

  }


  connectToServer(formData)
  {
    // console.log('connect To Server', formData.value);

    if(formData.value.deviceCourtNumber != -1)
    {
      
      formData.value['adminID'] = this.userTokenInfo.userID;

      // Set the LocalStorage for the Device (Tablet) to be used at each court
      // Save the Unique Device Info in Local Storage
      this.scoreTrackerService.setLocalStorageDeviceInfo(formData.value);

      this.scoreTrackerService.connectToServer(this.connectionInfo).subscribe(
      (data2: any) =>
      {
        console.log('connectToServer data : ', data2);
      },
      (error: any) => 
      {
        console.log('Error ', error);
        alert(error);
      });       
    }
    else
    {
      // this.snackBar.open('Please Select Valid Court Number', null, { duration: 4000 });
      alert('Please Select Valid Court Number');
    }

  }

  disconnectFromServer()
  {
    console.log('disconnect From Server');
    this.scoreTrackerService.disconnectFromServer();

  }


  gotToTestPage()
  {
      // Navigate to Match Congratulations Page
    this.router.navigate([`match-congratulations`]);        
  }




  // ----------------------------------------------------
  // Check to See if the Device has been setup previously
  // Stored in local storage
  // ----------------------------------------------------
  checkDeviceSetup()
  {
    // if(event != undefined)
    // {
    //   event.preventDefault();
    // }
    
    const deviceSetupInfo = this.scoreTrackerService.getLocalStorageDeviceInfo();   

    if(deviceSetupInfo !== null)
    {
      // this.uniqueDeviceInfo.adminID = deviceSetupInfo.adminID;
      this.connectionInfo.deviceCourtNumber = deviceSetupInfo.deviceCourtNumber;
      this.connectionInfo.deviceName = deviceSetupInfo.deviceName;

      this.snackBar.open('Device is Currently Setup', null, { duration: 1000 });
      // alert('Device is Currently Setup');
    }
    else
    {
      // this.snackBar.open('Device is NOT currently Setup', null, { duration: 5000 });
      alert('Device is NOT currently Setup');
    } 
  }


  // ----------------------------------------------------
  // Device Setup FORM
  // Click the Save Button
  // ----------------------------------------------------
  onDeviceSetup(form)
  {
    console.log(form.value);
    form.value['adminID'] = this.userTokenInfo.userID;
    // Set the LocalStorage for the Device (Tablet) to be used at each court
    // Save the Unique Device Info in Local Storage
    this.scoreTrackerService.setLocalStorageDeviceInfo(form.value); 

  }  

  // ----------------------------------------------------
  // Device Setup FORM
  // Reset the Admin Device Info to Defaults
  // ----------------------------------------------------
  resetDeviceDetails()
  {
    
  }

  // ----------------------------------------------------
  // Device Setup FORM
  // Completely Remove the Admin Device Info from LocalStorage
  // ----------------------------------------------------
  removeAdminDeviceInfo()
  {
    this.scoreTrackerService.removeLocalStorageDeviceInfo();
    location.reload();
  }


  toggleDebug()
  {
    // if(this.showDebug)
    // {
    //   this.showDebug = false;
    // }
    // else
    // {
    //   this.showDebug = true;
    // }

    this.openDeviceDebugDialog();
  }

  // --------------------------------------------------------
  // Open Browser Info Dialog to get browser info if needed
  // --------------------------------------------------------
  openDeviceDebugDialog() 
  {

    // console.log('sdjflskjfslj');
    this.deviceDebugDialog = this.dialog.open(DialogDeviceDebugDialog, {
      minWidth: '80%',
      height: '80%',
      disableClose: false,
      data: {
        data: this.socketInfo 
      },
      backdropClass: 'backdropBackgroundLight'      
    });

    this.deviceDebugDialog.afterClosed().subscribe(result => 
    {
      console.log('Result of Device Debug Dialog : ', result);
    });    
 
  } 


  getLatestMatchInfo()
  {
    this.scoreTrackerService.getLatestMatchInfo().subscribe(
      (data: any) => 
      {
        // debugger
        //
        this.router.navigate([`score-tracker/${ data.data.eventID }`],
        {
            queryParams: 
            {   
                leagueID:  data.data.eventID,
                matchID: data.data.matchID,
                gameID: data.data.gameID
            }                    
        });        
      },
      (error) => 
      {
        alert(error.message);
      });
  }  


}
